import { TOptions } from 'i18next';
import React, { Fragment, ReactNode } from 'react';
import ReactDOMServer from 'react-dom/server';

import A from '../components/Link/Link';
import { WebRoute, YagaExternalWebRoute } from '../config/fe-routes';
import i18n from './i18n';

/**
 * Translates array of strings into one translation
   1) Translation looks like this:
      "profile": [
        "Palun kontrolli",
        "<<profiili>>",
        "oma e-mailiaadressi õigsust, et Müüja saaks Sind teavitada kauba teelepanemisest."
      ],
   2) translationArrayString here is 'profile'
 * @param translationArrayString - string
 * @param target - WebRouten
 *
 * @returns ReactNode
 */
// eslint-disable-next-line max-len
export function translateTextArrayWithInnerLink(
  translationArrayString: string,
  target: WebRoute | YagaExternalWebRoute,
  options?: TOptions & {
    addSpacesAroundLink?: boolean;
  },
): ReactNode[] {
  const translatedArray = i18n.t(translationArrayString, {
    returnObjects: true,
    ...options,
  }) as unknown as string[];

  const addSpacesAroundLink = options?.addSpacesAroundLink ?? true;

  return translatedArray.map((text, index) => {
    if (text?.startsWith('[[') && text?.endsWith(']]')) {
      return (
        <A {...target} key={'translation-' + text} className="primary">
          {text.replace(/(\[\[|]])/gim, '')}
        </A>
      );
    }

    const isTextHTML = isHtml(text);

    if (isTextHTML) {
      return <span key={'translation-' + text} dangerouslySetInnerHTML={{ __html: text }} />;
    }

    return (
      <Fragment key={'translation-' + text}>
        {addSpacesAroundLink && index === translatedArray.length - 1 && <>&nbsp;</>}
        {text}
        {addSpacesAroundLink && index === 0 && <>&nbsp;</>}
      </Fragment>
    );
  });
}

export function isHtml(input: string): boolean {
  return /<[a-z]+\d?(\s+[\w-]+=("[^"]*"|'[^']*'))*\s*\/?>|&#?\w+;/i.test(input);
}

export function addElementsInHTMLString(string: string, replaceWith: { [key: string]: ReactNode }): string {
  Object.keys(replaceWith || {}).forEach((key) => {
    if (string.includes(`[[${key}]]`)) {
      string = string.replace(`[[${key}]]`, ReactDOMServer.renderToString(replaceWith[key]));
    }
  });

  return string;
}
